import type { TOC } from '@ember/component/template-only';
import { PrismButton } from '@mylighthouse/prism-ember';

interface GeneralDropdownsTriggersTriggerPowerSelectKebabSignature {
  Args: {};
}

const GeneralDropdownsTriggersTriggerPowerSelectKebab = <template>
  <div class="trigger__content flex items-center">
    <PrismButton @buttonType="ghost" @icon="kebab" />
  </div>
</template> satisfies TOC<GeneralDropdownsTriggersTriggerPowerSelectKebabSignature>;

export default GeneralDropdownsTriggersTriggerPowerSelectKebab;
